import selectors from '../../../../redux/selectors/Index';
import SeatsScreenController from '../../SeatsScreenController';
import Constants from '../../../../model/AppConfiguration';

export default {
  getSeatsWithPassengers,
  selectSeat,
};

/**
 * appends passengers to seats list
 * returns updated seats list for SeatSelection screen render
 * and flights with updated seats and passengers
 * @param {array} flights List of objects (flights)
 * @param {string} routeId Currently selected route ID
 */
function getSeatsWithPassengers (flights, routeId) {
  let seats = selectors.flights.getSeatsForFlightByRouteId(flights, routeId);
  let exitRow = seats.exitRow || Constants.DEFAULT_EXIT_ROW;
  seats = seats.seats;
  let passengersWithSeat = selectors.flights.getPassengersForFlightWithSeats(flights, routeId);
  for (let i = 0; i < passengersWithSeat.length; i++) {
    let passenger = passengersWithSeat[ i ];
    let seat = seats.find(seat => seat.seatId === passenger.seatId);
    if (seat) {
      seat.passenger = passenger.id;
    }
  }
  return { exitRow, seats, flights };
}

/**
 * removes passenger from last seat to newly selected seat
 * updates (redux) flights so new seat can be visible on passengers list and seat selection
 * @param {string} selectedSeat newly selected seat for (currently active) passenger
 */
function selectSeat (selectedSeat) {
  if (!selectedSeat || !selectedSeat.available) {
    return;
  }
  const { selectedPassenger, routeId } = this.props;

  if (selectedSeat.passenger === selectedPassenger) {
    return;
  }

  const { seats, flights } = this.state;

  let previouslySelectedSeat = seats.find(seat => seat.passenger === selectedPassenger);
  if (previouslySelectedSeat) {
    previouslySelectedSeat.passenger = '';
  }
  selectedSeat.passenger = selectedPassenger;
  let flight = flights.find(flight => flight.routeId === routeId);
  let passenger = flight.passengers.find(passenger => passenger.id === selectedPassenger);
  let previousPassenger = flight.passengers.find(
    passenger => passenger.seatId === selectedSeat.seatId
  );

  if (passenger) passenger.seatId = selectedSeat.seatId;
  if (previousPassenger) previousPassenger.seatId = ''; // unseat passenger with selected seat

  this.props.actions.updateFlights(flights);
  this.props.actions.changeActivePassenger(
    SeatsScreenController.changePassenger(flight.passengers, selectedPassenger)
  );
}



// WEBPACK FOOTER //
// ./src/containers/seats/common/seatSelection/SeatSelectionController.js